/** @format */

// To share the state between components write thw following three lines
// Otherwise each component creates a new instance of the reactive state object that can not sher the state
import Vue from 'vue'
import VueCompositionApi from '@vue/composition-api'
Vue.use(VueCompositionApi)

async function getExchangeRates(excUnit) {
	const now = Date.now()
	if (sekBulkCache.data && now - sekBulkCache.ts < RATE_TTL_MS) {
		return sekBulkCache.data[excUnit]
	}

	const response = await fetch(
		`https://api.freecurrencyapi.com/v1/latest?apikey=fca_live_xKXNX5PhvGE9yikxSSWikKkQLxZofwdn56x2HeyW&currencies=EUR%2CUSD%2CNOK%2CDKK%2CTRY%2CPLN&base_currency=SEK`,
	)
	const result = await response.json()
	sekBulkCache = { data: result.data, ts: now }
	return result.data[excUnit]
}
// Simple in-memory caching to reduce network calls and speed up lookups
const RATE_TTL_MS = 10 * 60 * 1000 // 10 minutes
let sekBulkCache = { data: null, ts: 0 }
const pairCache = new Map()

function getExchangeRatesCross(excUnit) {
	const cacheKey = `${excUnit}->SEK`
	const now = Date.now()
	const cached = pairCache.get(cacheKey)
	if (cached && now - cached.ts < RATE_TTL_MS) {
		return Promise.resolve(cached.value)
	}

	return fetch(
		`https://api.freecurrencyapi.com/v1/latest?apikey=fca_live_xKXNX5PhvGE9yikxSSWikKkQLxZofwdn56x2HeyW&currencies=SEK&base_currency=${excUnit}`,
	)
		.then((response) => response.json())
		.then((result) => {
			const value = result.data['SEK']
			pairCache.set(cacheKey, { value, ts: now })
			return value
		})
}
// ? ---------------------------------------------------------------------------------------------------
export default function useExchangeRate() {
	return {
		getExchangeRates,
		getExchangeRatesCross,
	}
}
// todo -------------------------------------------------------------------------------------------------
